<template>
  <div>
    <div class="page-title">編輯作業</div>
    <div class="page-box">
      <jobFrom :formLabelAlign="formLabelAlign" ref="form"></jobFrom>
      <div class="page-notice">請注意：標有 (<span class="star-mark">*</span>) 的為必填項。</div>
      <div class="page-button">
        <el-button
            type="info"
            @click="onSubmit"
            :loading="submitting"
            :disabled="submitting"
        >
          {{ submitting ? "提交中..." : "提交" }}
        </el-button>
        <el-button type="success" @click="backIndexpage">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeworksDetail, putHomeworks } from '@/api/homeworks'
import jobFrom from "./components/jobFrom.vue";

export default {
  components: { jobFrom },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      submitting: false, // 提交状态（防重复）
      formLabelAlign: {
        number: null,
        lang: null,
        gradeId: null,
        grade: {
          name: null,
          price: null,
        },
        startDate: null,
        endDate: null,
        passScore: null,
        homeworkScopes: [
          {
            topicNumber: null,
            practiseNumber: null,
            randomNumber: null,
          },
        ],
        students: [],
      },
    };
  },
  created() {
    this.getHomeworksDetail();
  },
  methods: {
    onSubmit() {
      // 防重复点击
      if (this.submitting) return;

      // 表单验证
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          this.putHomeworks();
        }
      });
    },

    async putHomeworks() {
      this.submitting = true; // 开始提交

      try {
        await putHomeworks(this.id, this.formLabelAlign);
        this.$message.success("編輯成功");
        this.$router.push({ name: "job" });
      } catch (err) {
        this.$message.error("編輯失敗，請稍後重試");
      } finally {
        this.submitting = false; // 结束提交
      }
    },

    backIndexpage() {
      this.$router.push("/job");
    },

    getHomeworksDetail() {
      getHomeworksDetail(this.id).then((v) => {
        this.formLabelAlign = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
.page-notice{
  margin-top: 20px;
}
</style>